<ng-container
  *ngIf="{
    hasAudio: hasAudio$ | async,
    hasVideo: hasVideo$ | async,
    hasScreen: hasScreen$ | async
  } as data"
>
  <!-- MICRO -->
  <button
    (click)="toggleAudio()"
    [attr.aria-pressed]="data.hasAudio"
    [ngClass]="{ enabled: data.hasAudio }"
    class="cng-ico_media_micro"
    title="{{ 'agent:panel.visio.microphone' | translate }} {{ 'commons:basic.channels.' + getState(data.hasAudio) | translate }}"
    type="button"
  ></button>
  <!-- END MICRO -->

  <!-- CAMERA -->
  <button
    (click)="toggleVideo()"
    [attr.aria-pressed]="data.hasVideo"
    [ngClass]="{ enabled: data.hasVideo }"
    class="cng-ico_visio"
    title="{{ 'agent:panel.visio.camera' | translate }} {{ 'commons:basic.channels.' + getState(data.hasVideo) | translate }}"
    type="button"
  ></button>
  <!-- END CAMERA -->

  <!-- SCREENSHARING -->
  <button
    (click)="toggleScreen()"
    [attr.aria-pressed]="data.hasScreen"
    [ngClass]="{ enabled: data.hasScreen }"
    class="cng-ico_cobrowsing"
    [disabled]="!data.hasScreen && (subscriberStreamList$ | async).length >= 1"
    title="{{ 'agent:panel.visio.screenSharing' | translate }} {{ 'commons:basic.channels.' + getState(data.hasScreen) | translate }}"
    type="button"
  ></button>
  <!-- END SCREENSHARING -->
</ng-container>
